import React from "react";
import { fmtUSD } from "../../lib/api";

export const usd = (v, compact = true) => fmtUSD(v, { compact });
export const num = (v, d = 0) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: d });

export const PLATFORM_COLOR = { GKE: "#00579e", EKS: "#ff9900", AKS: "#0078d4", OKE: "#c74634" };
export const STATUS_STYLE = {
  optimized: { label: "Optimized", cls: "bg-[#dcfce7] text-[#15803d] border-[#bbf7d0]" },
  partial: { label: "Partial", cls: "bg-[#fef3c7] text-[#92400e] border-[#fde68a]" },
  rollback: { label: "Rollback", cls: "bg-[#fee2e2] text-[#b91c1c] border-[#fecaca]" },
  not_attached: { label: "Not attached", cls: "bg-[hsl(var(--cs-tint))] text-muted-foreground border-border" },
};

export const Kpi = ({ label, value, sub, accent, testId }) => (
  <div className="cs-card px-4 py-3" data-testid={testId}>
    <div className="text-[10px] uppercase tracking-[0.12em] text-muted-foreground">{label}</div>
    <div className={`cs-mono text-xl font-semibold mt-0.5 ${accent || ""}`}>{value}</div>
    {sub && <div className="text-[11px] text-muted-foreground mt-0.5">{sub}</div>}
  </div>
);

export const Th = ({ children, right }) => (
  <th className={`px-3 py-2 text-[10px] uppercase tracking-[0.12em] font-medium text-muted-foreground ${right ? "text-right" : "text-left"}`}>
    {children}
  </th>
);

export const Td = ({ children, right, mono, className = "" }) => (
  <td className={`px-3 py-2 ${right ? "text-right" : ""} ${mono ? "cs-mono" : ""} ${className}`}>{children}</td>
);

export const Pill = ({ children, cls = "", testId }) => (
  <span data-testid={testId} className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border uppercase tracking-wide ${cls}`}>
    {children}
  </span>
);

export const PlatformBadge = ({ platform, provider }) => (
  <span className="inline-flex items-center gap-1.5">
    <span className="w-1.5 h-1.5 rounded-full" style={{ background: PLATFORM_COLOR[platform] || "#94a3b8" }} />
    <span className="font-medium">{platform}</span>
    <span className="text-muted-foreground text-[11px]">{provider}</span>
  </span>
);

export const SectionTitle = ({ children, hint }) => (
  <div className="mb-3">
    <h3 className="cs-heading text-sm font-semibold">{children}</h3>
    {hint && <p className="text-[11px] text-muted-foreground mt-0.5">{hint}</p>}
  </div>
);

export const Loading = ({ label = "Loading…", testId }) => (
  <div className="cs-card p-10 text-center text-sm text-muted-foreground" data-testid={testId}>{label}</div>
);

// FastAPI returns `detail` as a string or as a list of validation objects.
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  if (typeof d === "string") return d;
  return e?.message || "Unexpected error";
};
